var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.9999C18.9164 13.6164 19.892 13.4386 20.6875 13.8935C21.633 14.4342 22.2529 15.4686 22.2529 16.6903C22.2527 18.3432 21.111 19.5058 20.2285 20.1698C19.5451 20.684 18.7938 21.0658 18.001 21.3778C17.2087 21.0651 16.4576 20.6839 15.7744 20.1698C14.8919 19.5058 13.7502 18.3433 13.75 16.6903C13.75 15.4665 14.3339 14.4548 15.3154 13.8935C16.1108 13.4387 17.0837 13.6167 18 13.9999Z",
    fill: "#FFB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06934 12.1094C9.14306 12.979 10.5107 13.5 12 13.5C12.5747 13.5 13.1307 13.4207 13.6592 13.2754C12.755 14.1458 12.2501 15.3549 12.25 16.6904C12.2506 18.7335 13.4527 20.1658 14.416 21H6.5957C5.16224 20.9998 4.00024 19.8378 4 18.4043C4 15.6021 5.6706 13.1915 8.06934 12.1094Z",
    fill: "#FFB400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C14.6234 2.5 16.75 4.62665 16.75 7.25C16.75 9.87335 14.6234 12 12 12C9.37665 12 7.25 9.87335 7.25 7.25C7.25 4.62665 9.37665 2.5 12 2.5Z",
    fill: "#FFB400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIconActive);
export default __webpack_public_path__ + "static/media/individual_icon_active.9113f2ccdfbeb01174064dc37572403a.svg";
export { ForwardRef as ReactComponent };